import * as fileStatuses from "helpers/fileStatus.json";


export function getFileStatusGroup(fileStatus) {
  switch (fileStatus) {
    case fileStatuses.STATUS_SENT:
    case fileStatuses.STATUS_PENDING_REVIEW:
    case fileStatuses.STATUS_APPROVED:
    case fileStatuses.STATUS_RESENT_FOR_APPROVAL:
      fileStatus = [
        fileStatuses.STATUS_SENT,
        fileStatuses.STATUS_PENDING_REVIEW,
        fileStatuses.STATUS_APPROVED,
        fileStatuses.STATUS_RESENT_FOR_APPROVAL,
        fileStatuses.STATUS_READY_TO_UPLOAD,
        fileStatuses.STATUS_UPLOAD_FAILED
      ];
      break;
    default:
      fileStatus = [fileStatus];
      break;
  }
  return fileStatus;
}

export const isFile = str => {
  const chunks = str.split(".");
  return chunks[1] ? true : false;
};

export const pendingStatuses = [
  fileStatuses.STATUS_SENT,
  fileStatuses.STATUS_PENDING_REVIEW,
  fileStatuses.STATUS_APPROVED,
  fileStatuses.STATUS_RESENT_FOR_APPROVAL
];

export const isPending = status => {
  return pendingStatuses.includes(status);
};
